import { FilterOptionKeys } from '@griply/types';
import {
  goalImpactFilterOptions,
  goalNoImpactFilterValue,
} from '@griply/utils';
import { TFunction } from 'i18next';
import { ThunderLightning16 } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';

export type Options = {
  t: TFunction;
};

export const noImpactValue = goalNoImpactFilterValue;

export const createGoalImpactFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.GoalImpact,
  label: t('general.filters.title.goal-impact'),
  placeholder: t('general.labels.select'),
  icon: ThunderLightning16,
  type: FilterOptionType.MultiSelect,
  selectOptions: goalImpactFilterOptions.map((value) => ({
    label:
      value === goalNoImpactFilterValue
        ? t('context-menus.filtering.task.filters.goal-impact.options.none')
        : t(`goal.impact.options.${value}.label`),
    value,
  })),
  canReset: true,
});
